export default "__VITE_ASSET__Dohf_c0Z__"